<template>
    <v-progress-circular
        v-if="$store.getters.isAuthenticated"
        :rotate="360"
        :size="32"
        :width="2"
        :value="countdown"
    >
        <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
                <v-btn @click="countdown = 0" v-on="tooltip" icon rounded>
                    <v-icon
                        class="rotate-refresh"
                        v-show="!$store.getters.getLoading"
                    >
                        mdi-autorenew
                    </v-icon>
                    <v-progress-circular
                        v-show="$store.getters.getLoading"
                        size="20"
                        :width="1"
                        indeterminate
                    />
                </v-btn>
            </template>
            <span class="text-no-wrap">{{ time }}</span>
        </v-tooltip>
    </v-progress-circular>
</template>
<script>
import groupRules from "../../utils/ability";

export default {
    data: () => ({
        time: "Loading...",
        countdown: 100,
        seconds: 60,
    }),
    created() {
        this.refresh();
        this.triggerCountdown();
    },
    methods: {
        async refresh() {
            // Update user information and his abillities
            try {
                await this.$store.dispatch("isLoggedIn");
                this.$ability.update(
                    groupRules(this.$store.getters.getLoggedUserGroup)
                );
                // Update token if needed
                if (this.newTokenNeeded()) {
                    await this.$store.dispatch("refreshToken");
                }
                // Update presented information
                await this.$store.dispatch("refreshInfo");
                // Save time of last data refresh
                const currentdate = new Date();
                this.time = `${this.$t(
                    "message.Updated"
                )} ${currentdate.getDate()}-${
                    currentdate.getMonth() + 1
                }-${currentdate.getFullYear()}  ${
                    currentdate.getHours() < 10
                        ? `0${currentdate.getHours()}`
                        : currentdate.getHours()
                }:${
                    currentdate.getMinutes() < 10
                        ? `0${currentdate.getMinutes()}`
                        : currentdate.getMinutes()
                }:${
                    currentdate.getSeconds() < 10
                        ? `0${currentdate.getSeconds()}`
                        : currentdate.getSeconds()
                }`;
            } catch (err) {
                this.time = this.$t("message.UnableToRefresh");
            }
        },
        newTokenNeeded() {
            const { exp } = JSON.parse(
                atob(this.$store.getters.getToken.split(".")[1])
            );
            const expiryDate = new Date(exp * 1000);
            const currentDate = new Date();
            // 36e5 is same as 60*60*1000 (converting milliseconds into hours)
            const hoursRemaining = Math.abs(expiryDate - currentDate) / 36e5;
            return hoursRemaining <= 4;
        },
        clearRefreshInterval() {
            // Clear interval id if there is one
            if (localStorage.getItem("intervalId")) {
                clearInterval(localStorage.getItem("intervalId"));
            }
        },
        triggerCountdown() {
            this.clearRefreshInterval();
            const intervalId = setInterval(() => {
                if (this.countdown <= 0) {
                    this.countdown = 100;
                    this.refresh();
                }
                this.countdown -= 100 / this.seconds;
            }, 1000);
            localStorage.setItem("intervalId", intervalId);
        },
    },
    watch: {
        "$i18n.locale": function () {
            this.time = this.time.replace(
                this.time.substr(0, this.time.indexOf(" ")),
                this.$t("message.Updated")
            );
        },
    },
    mounted() {
        if (localStorage.getItem("dark")) {
            this.$vuetify.theme.dark = localStorage.getItem("dark") === "true";
        }
        if (localStorage.getItem("lang")) {
            this.$i18n.locale = localStorage.getItem("lang");
        }
    },
    beforeDestroy() {
        this.clearRefreshInterval();
    },
};
</script>
